import { useTranslation } from 'react-i18next';

import AISparkles from '@/components/common/AISparkles';
import { Checkbox } from '@/components/shadcn/checkbox';
import { Field, FieldLabel } from '@/components/shadcn/field';
import useLocalSettings from '@/stores/useLocalSettings';

export default function OnlyShowRelevantToggle() {
  const { t } = useTranslation();
  const { onlyShowRelevant, actions } = useLocalSettings();

  return (
    <div className="bg-background sticky top-0 z-10 border-b p-2.5 shadow">
      <Field orientation="horizontal">
        <Checkbox
          id="only-show-relevant"
          name="only-show-relevant"
          checked={onlyShowRelevant}
          onCheckedChange={() => actions.toggleOnlyShowRelevant()}
        />

        <FieldLabel
          htmlFor="only-show-relevant"
          className="cursor-pointer gap-1"
        >
          {t('SHOW_RELEVANT_ONLY')}
          <AISparkles>{t('AI_CONTENT_EXTRACTED_LABEL')}</AISparkles>
        </FieldLabel>
      </Field>
    </div>
  );
}
